import React from 'react';
import { useCart } from '../../context/CartProvider'; // Import useCart hook
import './ShoppingBag.css'; // Optional: Add styles for the shopping bag
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'; // We'll need this to call the API

function ShoppingBag() {
  const { cart, removeItem, updateQuantity, clearCart } = useCart(); // Access cart state and functions

  // Calculate the total price of the cart
  const totalPrice = cart.reduce((total, item) => total + item.price * item.quantity, 0);
  const navigate = useNavigate();
  const location = useLocation();

  const handleCheckout = async () => {
  // 1. Check if user is logged in (like in Nav.js)
  const isAuthenticated = localStorage.getItem('authToken');

  if (!isAuthenticated) {
    // 2. If NOT logged in, redirect to login
    // We save the 'from' location so we can come back
    navigate('/login', { state: { from: location } });
    return; // Stop here
  }

  // 3. If IS logged in, create the order and get the Stripe URL
  try {
    // A. Create the order in your database
    // This calls the '/api/v1/checkout/' endpoint
    const orderData = {
      items: cart.map(item => ({
        product: item.id,
        quantity: item.quantity,
        price: item.price
      }))
    };

    // Get the auth token to send with the request
    const config = {
      headers: {
        'Authorization': `Token ${localStorage.getItem('authToken')}`
      }
    };

    const orderResponse = await axios.post('/api/v1/checkout/', orderData, config);
    const order_id = orderResponse.data.id;

    // B. Create the Stripe session
    // This calls the '/api/v1/create-checkout-session/...' endpoint
    const stripeResponse = await axios.post(`/api/v1/create-checkout-session/${order_id}/`, {}, config);

    // C. Redirect to Stripe
    window.location.href = stripeResponse.data.checkout_url;

  } catch (error) {
    console.error('Checkout failed:', error);
    // You could show an error message to the user here
  }
};

  return (
    <div className='shopping-bag'>
      <h2>YOUR CART</h2>
      {cart.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <>
          <ul className='cart-items'>
            {cart.map((item) => (
              <li key={item.id} className='cart-item'>
                <img src={item.get_image} alt={item.name} className='cart-item-image' />
                <div className='cart-item-details'>
                  <h3>{item.name}</h3>
                  <p>€{item.price}</p>
                  <div className='cart-item-quantity'>
                    <label htmlFor={`quantity-${item.id}`}>Quantity </label>
                    <input
                      type='number'
                      id={`quantity-${item.id}`}
                      value={item.quantity}
                      min='1'
                      onChange={(e) => updateQuantity(item, parseInt(e.target.value))}
                    />
                  </div>
                  <div className='rmv-btn'>
                    <button onClick={() => removeItem(item)} className='remove-item-button'>
                      X
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <div className='cart-summary'>
            {/* <button onClick={clearCart} disabled={true} className='clear-cart-button'>
              Clear Cart
            </button> */}

          <Link to='/checkout'>
            <button className='sb-pay-now-button'>
              <span>Checkout</span>
              <span>€{totalPrice.toFixed(2)}</span>
            </button>
          </Link>

          </div>
        </>
      )}
    </div>
  );
}

export default ShoppingBag;
